<template>
  <MenuPopover
    trigger="click"
    class="TimelineSettingsMenu"
    :bound-to="{ x: 'container' }"
    :margin="{ left: 8, right: 8 }"
    :trigger-attrs="{ title: $t('timeline.settings_menu') }"
    :items="items"
  >
    <template #trigger>
      <FAIcon icon="sliders" />
    </template>
  </MenuPopover>
</template>

<script src="./timeline_settings_menu.js"></script>
